var waitFor = require('../utils/waitFor');

waitFor('body.page-template-create-a-part-landing', function() {

  $('#cap-series-filter').on('keyup', function(e){
    var curValue = $(e.currentTarget).val().toLowerCase().trim(),
      $visibleEls;

    // handle return key:
    // go to series detail when there's only one result
    if(e.keyCode == 13){
      $visibleEls = $('#cap-series-list li[data-series-code^="' + curValue + '"]');

      if($visibleEls.length == 1)
        window.location = $visibleEls.find('a').attr('href');

      return e.preventDefault();
    }

    if(curValue.length > 0){
      $('#cap-series-list li:not([data-series-code^="' + curValue + '"])').hide();
      $visibleEls = $('#cap-series-list li[data-series-code^="' + curValue + '"]');
    }else{
      $visibleEls = $('#cap-series-list li');
    }

    if($visibleEls.length > 0){

      $('.no-series-match').hide();

      // sort what's still visible so nth-child CSS rules still work right
      $visibleEls.sort(function(a, b){
        var an = $(a).data('series-code'),
          bn = $(b).data('series-code');

        if(an > bn)
          return 1;

        if(an < bn)
          return -1;

        return 0;
      });

      $visibleEls.detach().prependTo($('#cap-series-list')).show();

    }else{
      $('.no-series-match').show();
    }

  });

  $('#cap-series-filter').focus();

});
